import './theme/variables.css';
import '@ionic/react/css/core.css';
import '@ionic/react/css/display.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/padding.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/typography.css';

import { Plugins } from '@capacitor/core';
import { IonApp } from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';
import React from 'react';
import { Route } from 'react-router-dom';

import { AuthContext } from './context/AuthContext';
import DBStorage from './library/DBStorage';
import { isWebView, passToWebView } from './library/Funcs';
import RequestCard from './pages/account/card/RequestCard';
import Messages from './pages/account/messages/message-list/MessageList';
import MessageView from './pages/account/messages/message-view/MessageView';
import MonthPayment from './pages/account/month-payment/MonthPayment';
import OrderList from './pages/account/orders/order-list/OrderList';
import OrderView from './pages/account/orders/order-view/OrderView';
import Payments from './pages/account/payments/Payments';
import BlogDetail from './pages/blog/BlogDetailPage';
import Blog from './pages/blog/BlogPage';
import CampaignDetail from './pages/campaigns/CampaignDetailPage';
import Campaign from './pages/campaigns/CampaignPage';
import Cart from './pages/cart/Cart';
import CategoryCampaigns from './pages/category/CategoryCampaigns';
import Contact from './pages/contact/Contact';
import Donation from './pages/donation/Donation';
import Fund from './pages/fund/Fund';
import Tab from './pages/home/Tab';
import DonationPayment from './pages/payment/Donation';
import FailedPayment from './pages/payment/Failed';
import Payment from './pages/payment/Payment';
import ProductDetail from './pages/shop/ProductDetailPage';
import Product from './pages/shop/ProductPage';
import Single from './pages/single/Single';
import Map from './pages/home/Home/Map';
import TreeDocuments from './pages/campaigns/TreeDocuments';
import Gallery from './pages/gallery/Gallery';
import EventDetailPage from './pages/tour/EventDetailPage';
import EventPage from './pages/tour/EventPage';
import RegisterEvent from './pages/tour/Register';

const { Device } = Plugins;

class App extends React.Component {
  state = {
    os: "",
    auth: false,
    initialTabIndex: 0,
    card: {
      show: false,
      title: "",
      message: ""
    },
    link: "",
    linkState: null as any
  }

  modalContainerRef = React.createRef<any>();

  constructor(props: any) {
    super(props)
  }

  componentDidMount() {
    document.body.style.setProperty('--status-bar-height', "24px");
    
    this.loadDeviceData();

    this.checkAuth();

    window.modalContainer = this.modalContainerRef;
  }

  // در صورت دریافت نوتیفیکیشن از  طریق اپلیکیشن و کلیک شدن آن، توسط این تابع بررسی شده و نتیجه مرتبط نمایش داده می شود
  notifChecker = async (isAuth: boolean) => {
    const data = JSON.parse(await passToWebView('notifChecker', '')!);

    if (data?.action == "project") {
      this.setState({
        link: `/campaign/${data.id}`
      })
    } else if (data?.action == "project_update") {
      this.setState({
        link: `/campaign/${data.id}`,
        linkState: { showUpdates: true }
      })
    } else if (data?.action == "blog") {
      this.setState({
        link: `/blog/${data.id}`
      });
    } else if (data?.action == "ticket_reply") {
      if (isAuth) {
        this.setState({
          link: `/account/messages/${data.id}`
        });
      }
    } else if (data?.action == "aid") {
      if (isAuth) {
        this.setState({
          link: "/account/monthly-pay"
        })
      }
    } else if (data?.action == "shop") {
      this.setState({
        initialTabIndex: 2
      })
    } else if (data?.action == "card_status") {
      this.setState({
        card: {
          show: true,
          title: "توجه",
          message: data?.message!,
        }
      })
    }
  }

  // بررسی نوع سیستم عامل
  loadDeviceData = async () => {
    const info = await Device.getInfo();

    window.layoutMode = info.operatingSystem == 'ios' ? 'ios' : 'md';

    this.setState({
      os: info.operatingSystem
    });
  }

  // بررسی احراز هویت کاربر
  checkAuth = async () => {
    const storage = await new DBStorage().initRet();
    const user = await storage.get('user')
    let isAuth = false;

    if (isWebView()) {
      const accessToken = await passToWebView("getPref", "access_token");
      isAuth = accessToken != "" && accessToken != null;
    } else {
      isAuth = user !== undefined && user != null && user.access_token != "";
    }

    this.setState({ auth: isAuth });

    if (isWebView()) {
      setTimeout(() => {
        this.notifChecker(isAuth);
      }, 1000)
    }
  }

  render() {
    return <AuthContext.Provider value={{ auth: this.state.auth }}>
      <IonApp className={isWebView() ? `webview ${this.state.os}` : `${this.state.os}`}>
        <IonReactRouter forceRefresh={false}>
          <Route path="/">
            <Tab checkAuth={this.checkAuth} initialTabIndex={this.state.initialTabIndex} alert={this.state.card} link={this.state.link} linkState={this.state.linkState} showShop={false} />
          </Route>
          <Route path="/shop">
            <Tab checkAuth={this.checkAuth} initialTabIndex={this.state.initialTabIndex} alert={this.state.card} link={this.state.link} linkState={this.state.linkState} showShop={true} />
          </Route>

          {this.state.auth ?
            <>
              <Route path="/account/monthly-pay">
                <MonthPayment auth={true} />
              </Route>
              <Route path="/account/request-card" component={RequestCard} />
              <Route path="/account/orders" component={OrderList} />
              <Route path="/account/orders/:order_id" component={OrderView} />
              <Route path="/account/messages" component={Messages} />
              <Route path="/account/messages/:message_id" component={MessageView} />
              <Route path="/account/payments" component={Payments} />

              <Route path="/account/payments/campaign/:campaign_id" component={Campaign} />
              <Route path="/account/payments/campaign/:campaign_id/:type" component={CampaignDetail} />
              <Route path="/account/payments/campaign/:campaign_id/donation" exact component={Donation} />
              <Route path="/account/payments/campaign/:campaign_id/tree-doc" component={TreeDocuments} />
            </>
            : null}

          <Route path="/page/:page" component={Single} />

          <Route path="/map" component={Map} />

          <Route path="/fund" component={Fund} />

          <Route path="/pay">
            <MonthPayment auth={false} />
          </Route>

          <Route path="/payment/donation/:is_app/:donation_id+" component={DonationPayment} />
          <Route path="/payment/donation/:param1/:param2/:param3/:param4/:is_app?" component={DonationPayment} />
          <Route path="/payment/failed/:is_app?" component={FailedPayment} />
          <Route path="/payment/success/:param1/:param2/:param3/:param4/:param5?/:is_app?" component={Payment} />

          <Route path="/contact" component={Contact} />

          <Route path="/category/:category_id" component={CategoryCampaigns} />

          <Route path="/campaign/:campaign_id" component={Campaign} />
          <Route path="/campaign/:campaign_id/detail/:type" component={CampaignDetail} />
          <Route path="/campaign/:campaign_id/donation" exact component={Donation} />
          <Route path="/campaign/:campaign_id/donation/:pay_do" exact component={Donation} />
          <Route path="/campaign/:campaign_id/tree-doc" component={TreeDocuments} />
          <Route path="/campaign/:campaign_id/images" component={Gallery} />

          <Route path="/map/campaign/:campaign_id" component={Campaign} />
          <Route path="/map/campaign/:campaign_id/detail/:type" component={CampaignDetail} />
          <Route path="/map/campaign/:campaign_id/donation" exact component={Donation} />
          <Route path="/map/campaign/:campaign_id/tree-doc" exact component={TreeDocuments} />
          <Route path="/map/campaign/:campaign_id/images" component={Gallery} />

          <Route path="/cart" component={Cart} />
          <Route path="/shop/:product_id" component={Product} />
          <Route path="/shop/:product_id/:type" component={ProductDetail} />
          <Route path="/shop/:product_id/images" component={Gallery} />

          <Route path="/tour/:event_id" component={EventPage} />
          <Route path="/tour/:event_id/:type" component={EventDetailPage} />
          <Route path="/tour/:event_id/images" component={Gallery} />
          <Route path="/tour/:event_id/detail/:type" component={EventDetailPage} />
          <Route path="/tour/register/:event_id" component={RegisterEvent} />

          <Route path="/blog/:blog_id" component={Blog} />
          <Route path="/blog/:blog_id/:type" component={BlogDetail} />
        </IonReactRouter>

        <div ref={this.modalContainerRef} />
      </IonApp>
    </AuthContext.Provider>
  }
}

export default App